import { CLEAR_PAGE } from '../base/types';
import { FETCH_PROBLEMS, CREATE_PROBLEM, UPDATE_PROBLEM, DELETE_PROBLEM } from './actionsTypes';

const INIT_STATE = {
  isLoading: false,
  isLoaded: false,
  data: [],
};

const problemsReducer = (state = INIT_STATE, { type, payload }) => {
  switch (type) {
    case `${FETCH_PROBLEMS}_PENDING`:
      return {
        ...state,
        isLoading: true,
      };
    case `${FETCH_PROBLEMS}_FULFILLED`:
      return {
        ...state,
        data: payload,
        isLoading: false,
        isLoaded: true,
      };
    case `${FETCH_PROBLEMS}_REJECTED`:
      return {
        ...state,
        isLoaded: true,
        isLoading: false,
      };

    case `${CREATE_PROBLEM}_FULFILLED`:
      return {
        ...state,
        data: [payload, ...state.data],
      };
    case `${UPDATE_PROBLEM}_FULFILLED`:
      return {
        ...state,
        data: state.data.map((i) => {
          if (Number(i.id) === Number(payload.id)) {
            return payload;
          }
          return i;
        }),
      };
    case `${DELETE_PROBLEM}_FULFILLED`:
      return {
        ...state,
        data: state.data.filter((i) => Number(i.id) !== Number(payload?.id)),
      };

    case CLEAR_PAGE:
      return payload === 'problems' ? INIT_STATE : state;

    default:
      return state;
  }
};

export default problemsReducer;
